import { defineExperiment } from '@cian/experiments/ab';

import { MARTECH_CASCADE_EXP_FOR_ESTIMATING_MKF } from './experiments';

/**
 * Микрофронтенд рекламных баннеров (ad-banner-frontend) вместо легаси-библиотек.
 * Эксперимент учитывается только при фичатоггле MarTech.AdBannerMicrofrontend.Enabled,
 * микрофронтенд показываем группе B (при выключенном фичатоггле — все на библиотеках).
 */
export const ExpAdBannerMicrofrontend = defineExperiment(MARTECH_CASCADE_EXP_FOR_ESTIMATING_MKF, {
  groups: ['A', 'B'] as const,
  default: 'A',
});
